import { Ingredient, IngredientType, IngredientTypeName } from "../data/ingredientModel";
import { createDiv, createElem, getOneByClass } from "../util";
import { game } from "../gameManager";
import { sounds } from "../soundManager";

export class BaseSlot {
    div: HTMLElement;
    ingredient: Ingredient;

    constructor() {};

    createElement(parent: HTMLElement) {
        this.div = createDiv(parent, "ingredient");

        const info = createDiv(this.div, "info");
        const iconContainer = createDiv(info, "icon-container");
        createElem("img", iconContainer, "icon");
        createDiv(info, "name-container");
        createDiv(info, "cost");
        createDiv(info, "remove", "&#x2715;");

        const symbols = createDiv(this.div, "reels");
        for (let i=0; i<3; i++){
            var reel = createDiv(symbols, "reel");
            createDiv(reel, "symbol");
        }
    }

    setIngredient(ingredient: Ingredient) {
        this.ingredient = ingredient;
        this.div.classList.remove("empty");

        const nameContainer = getOneByClass("name-container", this.div);
        nameContainer.innerHTML = "";
        createElem("h4", nameContainer, "", ingredient.name);
        createElem("h3", nameContainer, "", IngredientTypeName[ingredient.type]);
        
        const icon = getOneByClass("icon", this.div) as HTMLImageElement;
        icon.src = `assets/ingredients/${this.ingredient.icon}.png`;

        getOneByClass("cost", this.div).innerHTML = `<span class="money">${this.ingredient.cost.toString()}</span><span class="coin"></span>`;

        const symbols = getOneByClass("reels", this.div);
        for (let i=0; i<3; i++){
            var symbol = ingredient.symbols[i];
            symbols.children[i].children[0].classList.add("symbol-"+symbol);
        }
    }

    // Can a given ingredient go in this slot
    fitsIngredient(ingredient: Ingredient) {
        return false;
    }
}

export class FixedSlot extends BaseSlot {
    constructor(public ingredient: Ingredient){
        super();
    }

    createElement(parent: HTMLElement) {
        super.createElement(parent);
        this.div.classList.add("fixed");
        this.setIngredient(this.ingredient);
    }
}

export class Slot extends BaseSlot {
    constructor(public ingredientType: IngredientType) {
        super();
    }

    createElement(parent: HTMLElement) {
        super.createElement(parent);
        
        this.div.classList.add("empty");
        const nameContainer = getOneByClass("name-container", this.div);
        createElem("h3", nameContainer, "", IngredientTypeName[this.ingredientType]);

        const icon = getOneByClass("icon", this.div) as HTMLImageElement;
        icon.src = `assets/ingredients/${IngredientTypeName[this.ingredientType].toLowerCase()}_icon.png`;

        this.div.onclick = () => this.showInventoryTab();
        getOneByClass("remove", this.div).onclick = () => this.clearIngredient();

        if (this.ingredient) {
            this.setIngredient(this.ingredient);
        }
    }

    clearIngredient(playSound = true) {
        if (this.ingredient) {
            this.ingredient = null;
            this.div.classList.add("empty");

            const nameContainer = getOneByClass("name-container", this.div);
            nameContainer.innerHTML = "";
            createElem("h3", nameContainer, "", IngredientTypeName[this.ingredientType]);

            const icon = getOneByClass("icon", this.div) as HTMLImageElement;
            icon.src = `assets/ingredients/${IngredientTypeName[this.ingredientType].toLowerCase()}_icon.png`;

            getOneByClass("cost", this.div).innerHTML = "";

            const symbols = getOneByClass("reels", this.div);
            for (let i=0; i<3; i++){
                symbols.children[i].children[0].className = "symbol";
                symbols.children[i].children[0].innerHTML = "";
            }

            game.recipeBook.currentPage.updateTotal(); // awkward
        
            if (playSound) {
                sounds.play("drop");
            }
        }
    }

    fitsIngredient(ingredient: Ingredient) {
        return (ingredient.type === this.ingredientType);
    }

    showInventoryTab() {
        game.inventory.selectTab(this.ingredientType);
    }
}